module.exports = __webpack_public_path__ + "img/add-photo-second-icon.8849aac2.svg";